<template v-if="variants.v1 === variant">
  <section
    class="layout-pt-lg layout-pb-lg"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`"
  >
    <div class="container">
      <div class="row">
       
        <div class="col-lg-4 col-md-12 tw-mt-4">
          <h2 class="text-uppercase">{{ vars.titleText }}</h2>
          <div class="mt-20">
            <h5 style="color: var(--c-secondary)">{{ vars.descriptionText }}</h5>
          </div>

          
          <div class="mt-30 d-none d-lg-block">
            <a
              :href="ROUTES.BLOGS"
              class="n-secondary"
            >
             {{ 'EXPLORE&nbsp;ALL&nbsp;ARTICLES' }}
            </a>
          </div>
        </div>

        
        <div class="col-lg-8 col-md-12">
          <div v-if="isBlogsLoading">
            <loader loader-color="var(--c-primary)" />
          </div>
          <div class="row">
            <div
              class="col-md-6 col-sm-12 mb-md-30 mb-15"
              v-for="(blog, index) in blogs"
              :key="`blog-${index}`"
            >
              <Theme8BlogsBlogCard
                :blog="blog"
                :index="index"
                :component="component"
              />
            </div>
          </div>

          
          <div class="mt-30 d-block d-lg-none text-start">
            <a
              :href="ROUTES.BLOGS"
              class="n-secondary"
            >
              {{ 'EXPLORE&nbsp;ALL&nbsp;ARTICLES' }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>



<script lang="ts">
import { mapState } from 'pinia';
import type { Component } from '~/types';
import indexGlobal from '~/mixins/index.global';
import { BlogsMixin } from '~/units/blogs/mixins/blogs.mixin';
import { ComponentMixin } from '~/mixins/component.mixin';
import { useBlogsStore } from '~/units/blogs/store';
import { useWebsiteStore } from '~/units/website/store';
import { ROUTES } from '~/constants/ui.constants';
import Loader from '~/components/common/Loader.vue';


export default defineNuxtComponent({
  name: 'Theme8OurBlog',

  mixins: [BlogsMixin, indexGlobal, ComponentMixin],

  components: {
    Loader,
   
  },

  data() {
    return {
      variants: {
        v1: 'v1',
        v2: 'v2',
      },
    };
  },

  async setup(props: { component: Component }) {
    const blogsStore = useBlogsStore();
    await blogsStore.fetchBlogsInPage(props.component);
  },

  computed: {
    ...mapState(useWebsiteStore, ['sidebarComponents']),
    ROUTES() {
      return ROUTES;
    },
    cards() {
      return this.groupedVariables.cards;
    },
  },
});
</script>